import { useMemo } from 'react';

import { isZigzagApp } from '@common/device-manager';
import { usePdpBaseInfo } from '@domains/pdp-common';

import { ProductSwatchItem } from '../components/ProductSwatchCard';
import { convertToComponentProps } from '../utils/convertToComponentProps';

export const useProductSwatchCarouselService = (catalogProductId: string) => {
  const { isLoading, data: pdpBaseInfo } = usePdpBaseInfo({ catalog_product_id: catalogProductId });

  const items = useMemo(() => {
    return convertToComponentProps(pdpBaseInfo?.product.color_swatch_carousel?.swatch_item_list ?? []);
  }, [pdpBaseInfo]);

  const goToAnotherProductDetailPage = (item: ProductSwatchItem) => {
    if (isZigzagApp(navigator.userAgent)) {
      window.location.assign(item.deeplinkUrl);
      return;
    }

    window.location.replace(item.productUrl);
  };

  return {
    loading: isLoading,
    items,
    goToAnotherProductDetailPage,
  };
};
